import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class RestoreEnvService {
    async restoreLiveToTest(fromClientId: number, toClientId: number) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/RestoreEnv/restorelivetotest`;
        let response = await getAuthenticatedFetch()(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sourceClientId: fromClientId, 
                targetClientId: toClientId
            })
        });
        
        const responsejson = await response.json();
        
        if (!response.ok) {
            throw new Error();
        }
        
        return responsejson;
    }

    async linkDatabase(appGroupName: string, fullDatabaseName: string, customerName: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/RestoreEnv/linkdatabase`;
        let response = await getAuthenticatedFetch()(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                appGroupName,
                fullDatabaseName,
                customerName
            })
        });

        if (!response.ok) {
            throw new Error(`An error has occured, please check network/activity logs.`);
        }

        return response.json();
    }
}

export default new RestoreEnvService();
